import CloseIcon from "../../assets/svg/CloseIcon";
import CustomPopUpProps from "../../services/context/customPopupProps.model";
import { useAdminContext } from "../../services/context/TourPopupContext";
import CustomText from "../atomic/CustomText";

function CustomPopUp({
  children,
  popUpTitle,
  hidePopUp,
  onlineOrder,
  popUpSubtitle,
  routeLeaving,
  subTitleClassName,
  hideClose,
  hideHeader,
  cardClassName,
  warningPopupNotificationSettings,
}: Readonly<CustomPopUpProps>): JSX.Element {
  const { isTourActive } = useAdminContext();
  const isMobile = window.innerWidth <= 1702;
  return (
    <div
      id="step5"
      className={`absolute h-[100vh] md:px-5 px-3 w-full ${!isTourActive ? "bg-[rgba(23,43,77,0.56)]" : ""
        } z-[9999] top-0 bottom-0 left-0 right-0 flex justify-center items-center`}
    >
      <div
        className={`bg-white ${warningPopupNotificationSettings && "md:w-[650px]"
          } p-6 rounded-md relative ${cardClassName ?? ""}`}
      >
        {!hideHeader && <div
          className={`flex justify-between ${!!popUpSubtitle ? "items-start" : "items-center"
            } mb-4`}
        >
          <div className="w-full">
            {!!popUpTitle && (
              <CustomText
                text={popUpTitle}
                fontWeight={"font-semibold"}
                className="text-royalBlue"
                fontSize={`${isMobile ? 'text-sm' : 'text-lg'}`}
              />
            )}
            {!!popUpSubtitle && (
              <CustomText
                text={popUpSubtitle}
                fontWeight="font-normal"
                fontSize={`${isMobile ? 'text-sm' : 'text-md'}`}
                className={`my-3 ${subTitleClassName}`}
              />
            )}
          </div>
          {!!onlineOrder === false && !hideClose && (
            <CloseIcon
              className={` ${isTourActive ? "cursor-not-allowed" : "cursor-pointer"
                } ${!!popUpSubtitle ? "mt-1" : ""}`}
              onClick={isTourActive ? undefined : hidePopUp}
            />
          )}
        </div>}
        <div className="max-w-[93vw]">
          {children}
        </div>
      </div>
    </div>
  );
}

export default CustomPopUp;
